import React from 'react';
import { makeStyles } from 'tss-react/mui';
import Button from '../../../base/ui/components/web/Button';
import AbstractPollsPane from '../AbstractPollsPane';
import PollCreate from './PollCreate';
import PollsList from './PollsList';
/* eslint-enable lines-around-comment */
const useStyles = makeStyles()(theme => {
    return {
        container: {
            height: '100%',
            position: 'relative',
            display: 'flex',
            flexDirection: 'column'
        },
        listContainer: {
            flex: 1,
            overflowY: 'auto',
            padding: '0 4px',
            '&::-webkit-scrollbar': {
                width: '4px'
            },
            '&::-webkit-scrollbar-track': {
                background: 'transparent'
            },
            '&::-webkit-scrollbar-thumb': {
                background: 'rgba(255, 255, 255, 0.15)',
                borderRadius: '4px'
            }
        },
        footer: {
            padding: '16px 24px',
            width: '100%',
            boxSizing: 'border-box',
            borderTop: `1px solid rgba(255, 255, 255, 0.06)`
        }
    };
});
const PollsPane = ({ createMode, isCreatePollsDisabled, onCreate, setCreateMode, t }) => {
    const { classes } = useStyles();
    return createMode
        ? React.createElement(PollCreate, { setCreateMode: setCreateMode })
        : React.createElement("div", { className: classes.container },
            React.createElement("div", { className: classes.listContainer },
                React.createElement(PollsList, { setCreateMode: setCreateMode })),
            !isCreatePollsDisabled && React.createElement("div", { className: classes.footer },
                React.createElement(Button, { accessibilityLabel: t('polls.create.create'), fullWidth: true, labelKey: 'polls.create.create', onClick: onCreate })));
};
/*
 * We apply AbstractPollsPane to fill in the AbstractProps common
 * to both the web and native implementations.
 */
// eslint-disable-next-line new-cap
export default AbstractPollsPane(PollsPane);
